import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PendingPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: '24px' }}>
      <div style={{ background: 'var(--white)', borderRadius: 'var(--radius)', padding: '48px 40px', maxWidth: '480px', width: '100%', textAlign: 'center' }}>

        <div style={{ fontFamily: "'Baloo 2', cursive", fontSize: '20px', fontWeight: 800, color: 'var(--brand-primary)', marginBottom: '28px' }}>
          MyPersonalGuruji
        </div>

        <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'var(--yellow-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', margin: '0 auto 20px' }}>
          🕐
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--text)', marginBottom: '10px' }}>
          Account under review
        </h2>

        <p style={{ fontSize: '13px', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '20px' }}>
          Thank you for registering{user?.name ? `, ${user.name}` : ''}! Our team is reviewing your account. You will receive an email once approved — usually within 24 hours.
        </p>

        <div style={{ background: 'var(--yellow-light)', border: '1px solid var(--yellow)', borderRadius: 'var(--radius-sm)', padding: '12px 16px', marginBottom: '28px', textAlign: 'left' }}>
          <div style={{ fontSize: '11px', fontWeight: 800, color: '#7C2D12', marginBottom: '4px' }}>What happens next?</div>
          {['Our admin reviews your registration details', 'You receive an approval email', 'Log in and start studying with your Guruji!'].map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px', fontSize: '12px', color: '#7C2D12' }}>
              <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: 'var(--yellow)', color: '#7C2D12', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 800, flexShrink: 0 }}>{i + 1}</span>
              {s}
            </div>
          ))}
        </div>

        <button onClick={handleLogout} className="btn-secondary btn-full">
          Back to Login
        </button>

        <p style={{ marginTop: '16px', fontSize: '11px', color: 'var(--muted)' }}>
          Questions? Email us at{' '}
          <a href="mailto:support@mypersonalguruji.com" style={{ color: 'var(--brand-primary)', fontWeight: 700 }}>
            support@mypersonalguruji.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default PendingPage;
